import { useState } from "react";
import {
  HiOutlineArrowRight,
  HiOutlineClock,
  HiOutlineLockClosed,
} from "react-icons/hi2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SubscribeModal from "./SubscribeModal";

/**
 * Horizontal promo row (badge + title + subtitle + Subscribe pill), matches mobile Market Data card.
 */
const SubscribePromoInlineCard = ({
  title,
  subtitle,
  badgeText,
  badgeIcon = "lock",
  delayMinutes,
  className = "",
  modalTitle,
  modalDescription,
}) => {
  const navigate = useNavigate();
  const { theme } = useSelector((state) => state.theme);
  const isDark = theme === "dark";
  const [showSubscribe, setShowSubscribe] = useState(false);

  const resolvedBadge =
    badgeText ?? (delayMinutes != null ? `DELAYED ${delayMinutes} MIN` : null);

  const BadgeIcon = badgeIcon === "clock" ? HiOutlineClock : HiOutlineLockClosed;

  const goSubscribe = () => {
    setShowSubscribe(false);
    navigate("/payment");
  };

  const openSubscribe = () => {
    if (modalTitle || modalDescription) {
      setShowSubscribe(true);
      return;
    }
    navigate("/payment");
  };

  return (
    <>
      <div
        className={`flex flex-col gap-3 rounded-2xl border px-3.5 py-3.5 sm:flex-row sm:items-center sm:gap-4 ${
          isDark
            ? "border-slate-600/30 bg-slate-800/90"
            : "border-slate-200/80 bg-white shadow-sm"
        } ${className}`}
      >
        <div className="min-w-0 flex-1 space-y-1">
          {resolvedBadge ? (
            <span
              className={`inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide ${
                isDark ? "bg-amber-500/15 text-amber-400" : "bg-amber-100 text-amber-800"
              }`}
            >
              <BadgeIcon size={11} aria-hidden />
              {resolvedBadge}
            </span>
          ) : null}
          <p
            className={`text-[13px] font-semibold leading-snug ${
              isDark ? "text-slate-100" : "text-slate-900"
            }`}
          >
            {title}
          </p>
          <p className={`text-[11px] leading-snug ${isDark ? "text-slate-400" : "text-slate-500"}`}>
            {subtitle}
          </p>
        </div>
        <button
          type="button"
          onClick={openSubscribe}
          className="inline-flex shrink-0 items-center justify-center gap-1.5 self-start rounded-full bg-indigo-600 px-4 py-2.5 text-xs font-semibold text-white shadow-md shadow-indigo-500/25 transition hover:bg-indigo-700 sm:self-center"
        >
          Subscribe
          <HiOutlineArrowRight size={14} />
        </button>
      </div>
      {(modalTitle || modalDescription) && (
        <SubscribeModal
          open={showSubscribe}
          onClose={() => setShowSubscribe(false)}
          title={modalTitle || title}
          description={modalDescription || subtitle}
        />
      )}
    </>
  );
};

export default SubscribePromoInlineCard;
